<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    永湖站<br>
站点介绍<br>
3号线永湖站位于龙岗大道横坪立交以南及锦利路口，车站西面有永湖路、189工业区、保安学校。南面有锦利路、永湖大厦、龙岗区第二职业技术学院、188工业区。该站为高架站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:36	23:17	3号线	2分15-20秒	4分30秒<br>
双龙	06:07	23:56	3号线	2分15-20秒	4分30秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:36	23:16	3号线	3分15秒	5分钟<br>
双龙	06:10	23:55	3号线	3分15秒	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:36	00:16	3号线	3分15秒	5分钟<br>
双龙	06:10	00:55	3号线	3分15秒	5分钟<br><br>

站点出口信息<br><br>
A1出入口:<br>
龙岗大道（东）、嘉和楼、新坡塘<br><br>
A2出入口:<br>
龙岗大道（东）、永湖大厦、鑫旺工业区、龙岗区第二职业技术学校、水浸围村<br><br>
C出入口:<br>
龙岗大道（西）、保安学校、保安社区、窝肚村、坑楼、189工业区<br><br>
公交换乘信息<br><br>
A2出入口:<br>
公交站名： 永湖地铁站<br>
906,M266,M268,M295,M314,高峰专线64,深惠3A,深惠3线,M357,M359,M394,M466,351,358,366，M208，M239,M396,M547<br><br>
C出入口:<br>
公交站名： 永湖地铁站<br>
906,M266,M268,M295,M314,M357,309,351,358,366,高峰64，深惠3A，深惠3线，M359,M208，M239，M394，M396，M466，M547，M563<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>